import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import DataBrowser from './components/DataBrowser';
import FilesTable from './components/Files';
import StorageStats from './components/StorageStats';
import Recording from './components/Recording';
import StationId from './components/StationId';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function RINEX() {
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState("");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };



    useEffect(() => {
    }, []);

    return (
        <React.Fragment>
            <h1 className="page-title"><span className="fw-semi-bold">RINEX Data</span></h1>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label={<h5>Data Browser</h5>} {...a11yProps(0)} />
                        <Tab label={<h5>Legacy Files</h5>} {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <DataBrowser />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <FilesTable />
                </TabPanel>
            </Box>
        </React.Fragment>
    );
}
